<template>
  <v-overlay
    :value="activator"
    opacity="0.5"
    :z-index="zIndex"
  >
    <v-container class="rounded-xl">
      <v-card :width="width" color="white" rounded class="rounded-xl">
        <v-card-title class="full-width third">
          <span class="d-flex justify-center flex-grow-1">{{ title }}</span>
          <v-icon size="28" color="white" class="justify-end" @click="closeModal">mdi-close</v-icon>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <slot name="body"></slot>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <div v-if="showDefaultActions">
            <Button
              :action="closeModal"
              label="Annuler"
              icon="mdi-arrow-u-left-top"
              class="mx-2"
            />
            <Button
              :action="action"
              :label="btnLabel"
              :icon="btnIcon"
              :loading="loading"
              class="mx-2"
            />
          </div>
          <slot name="actions"></slot>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-overlay>
</template>

<script>
import { computed } from '@vue/composition-api';
import Button from './Button.vue';

export default {
  components: { Button },
  props: {
    title: {
      type: String,
      default: null
    },
    activator: { type: Boolean },
    action: { type: Function, default: null },
    closeModal: { type: Function, default: null },
    btnLabel: { type: String, default: 'effacer' },
    btnIcon: { type: String, default: 'mdi-broom' },
    width: { type: Number, default: 500 },
    loading: { type: Boolean, default: false },
    zIndex: { type: String, default: null }
  },
  setup (_, { slots }) {
    const showDefaultActions = computed(() => !slots || !(Object.keys(slots).includes('actions')));

    return { showDefaultActions };
  }
};
</script>
